import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import formStyles from '../../styles/modules/Form.module.scss'
import Image from 'next/image'

export interface RequestData {
  email: string
}

const schema = yup.object().shape({
  email: yup.string().email().required(),
})

interface RequestAccountFormProps {
  title: string
  description: string
  onSubmit: (data: RequestData) => void
  requestError?: string
  requestSuccess?: string
  requestSuccessDescription?: string
}

const RequestAccountForm: React.FC<RequestAccountFormProps> = (props) => {
  const { register, handleSubmit, formState } = useForm<RequestData>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
    },
    mode: 'all',
  })

  const errors = formState.errors

  const onSubmit = async (data: RequestData) => {
    props.onSubmit(data)
  }

  return (
    <section className={`${formStyles.panel}`}>
      <div className="d-flex flex-column content">
        <header className="d-flex align-items-center">
          <a href="/login" className="d-flex my-auto">
            <Image
              src="/static/icons/common/back-arrow.svg"
              width={32}
              height={32}
              alt="Back"
            />
          </a>
          <h1 className={`${formStyles['auth-title']}`}>{props.title}</h1>
        </header>
        {props.requestSuccess && (
          <div
            className={`mt-5 d-flex flex-column ${formStyles['success-content']}`}
          >
            <div className={`${formStyles['success-header']}`}>
              {props.requestSuccess}
            </div>
            <div className={`${formStyles['success-description']}`}>
              {props.requestSuccessDescription}
            </div>
          </div>
        )}
        {!props.requestSuccess && (
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={`${formStyles['auth-container']}`}
            autoComplete="off"
          >
            <div className={`${formStyles['description']}`}>
              {props.description}
            </div>
            <div className="form-group mb-auto">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <div className="form-group__fields">
                <input type="hidden" autoComplete="off" />
                <input
                  type="email"
                  className={`
                    form-control auth-input
                    ${errors.email ? 'is-invalid' : ''}
                    ${formState.isValid ? 'is-valid' : ''}
                  `}
                  {...register('email')}
                  autoFocus={true}
                  defaultValue=""
                  autoComplete="off"
                />
              </div>
              {errors.email && (
                <span className="form-error">{errors.email.message}</span>
              )}
              <div className="auth-message-container">
                {props.requestError && (
                  <span className="form-group__fields--error">
                    {props.requestError}
                  </span>
                )}
              </div>
            </div>

            <div className={`${formStyles['form-action']}`}>
              <button
                type="submit"
                className="btn btn-purple auth-button mb-3"
                disabled={!formState.isValid}
              >
                Send Instructions
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  )
}

export default RequestAccountForm
